import {useContext, createContext, useState, PropsWithChildren} from 'react'
import {useNavigate} from 'react-router-dom'
import {LoginRequest} from '../../types/LoginRequest'
import {Route} from '../../router'

interface AuthContextProps {
    token?: string
    test?: string
    user?: any
    loginAction: (data: LoginRequest) => Promise<boolean>
    logOut: () => void
}

const AuthContext = createContext<AuthContextProps>({
    loginAction: async () => false,
    logOut: () => {},
    token: localStorage.getItem('site') || undefined,
    test: localStorage.getItem('site') || undefined,
})

const AuthProvider = ({children}: PropsWithChildren) => {
    const [user, setUser] = useState<any>(null)
    const [token, setToken] = useState(localStorage.getItem('site') || '')
    const navigate = useNavigate()
    const loginAction = async (data: LoginRequest): Promise<boolean> => {
        try {
            // const response = await fetch('your-api-endpoint/auth/login', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(data),
            // })
            // const res = await response.json()
            const res =
                data.name === 'test' && data.password === 'test123'
                    ? {
                          data: {user: {name: 'John Doe'}},
                          token: 'your-jwt-token',
                          message: 'Login successful',
                      }
                    : {message: 'Invalid credentials'}

            if (res.data) {
                setUser(res.data.user)
                setToken(res.token)
                localStorage.setItem('site', res.token)
                navigate(Route.HOME, {replace: true})
                return true
            }
            throw new Error(res.message)
        } catch (err) {
            console.error(err)
        }
        return false
    }

    const logOut = () => {
        setUser(null)
        setToken('')
        localStorage.removeItem('site')
        navigate('/login')
    }

    return (
        <AuthContext.Provider
            value={{
                token,
                user,
                loginAction,
                logOut,
                test: localStorage.getItem('site') || undefined,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider

export const useAuth = () => {
    return useContext(AuthContext)
}
